// Display helpers for the Strava Sync page.

const TYPE_LABELS: Record<string, string> = {
  EBikeRide: 'E-Bike Ride',
  Ride: 'Ride',
  Run: 'Run',
}

/** A Strava activity type ('VirtualRide', 'Alpine skiing', ...) as words. */
export function typeLabel(type: string) {
  return TYPE_LABELS[type] ?? type.replace(/([a-z])([A-Z])/g, '$1 $2')
}

/** Seconds as h:mm:ss, or m:ss under an hour. */
export function formatElapsed(seconds: number | undefined) {
  if (!seconds) return '—'
  const s = Math.round(seconds)
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const ss = String(s % 60).padStart(2, '0')
  return h ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`
}

// Strava's start_date_local is the athlete's wall-clock time marked as UTC, so it's shown in UTC.
const dateFormat = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' })
const timeFormat = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' })

export function formatStart(local: string) {
  const d = new Date(local)
  return { date: dateFormat.format(d), time: timeFormat.format(d) }
}
